export const SUMMARY_ELEMENT_ID = "summary";
